import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { money } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import FullScreenLoader from "@/components/FullScreenLoader";
import { InstallDrelik } from "@/components/InstallDrelik";
import { ShoppingBag, DollarSign } from "lucide-react";

export default function CustomerAccount() {
  const { slug } = useParams();
  const [c, setC] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/shop/account").then((r) => setC(r.data)); }, []);
  if (!c) return <FullScreenLoader />;

  const set = (k, v) => setC((x) => ({ ...x, [k]: v }));

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/shop/account", { name: c.name, phone: c.phone, address: c.address });
      toast.success("Account updated");
    } catch { toast.error("Save failed"); }
    setSaving(false);
  };

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-8 space-y-6">
      <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">Your account</h1>

      <div className="grid grid-cols-2 gap-4">
        <Card className="p-4 rounded-xl border-border"><div className="flex items-center gap-2 text-muted-foreground text-sm"><DollarSign className="h-4 w-4" /> Lifetime spend</div><p className="text-xl font-bold mt-1">{money(c.lifetime_sales)}</p></Card>
        <Card className="p-4 rounded-xl border-border"><div className="flex items-center gap-2 text-muted-foreground text-sm"><ShoppingBag className="h-4 w-4" /> Orders</div><p className="text-xl font-bold mt-1">{c.total_orders}</p></Card>
      </div>

      <Card className="p-6 rounded-xl border-border space-y-4">
        <h3 className="font-semibold">Profile</h3>
        <div className="space-y-2"><Label>Name</Label><Input value={c.name} onChange={(e) => set("name", e.target.value)} className="h-11" data-testid="account-name" /></div>
        <div className="space-y-2"><Label>Email</Label><Input value={c.email} disabled className="h-11 opacity-60" /></div>
        <div className="space-y-2"><Label>Phone</Label><Input value={c.phone || ""} onChange={(e) => set("phone", e.target.value)} className="h-11" data-testid="account-phone" /></div>
        <div className="space-y-2"><Label>Saved address</Label><Textarea value={c.address || ""} onChange={(e) => set("address", e.target.value)} rows={3} data-testid="account-address" /></div>
        <div className="flex justify-between items-center">
          <Link to={`/store/${slug}/orders`} className="text-sm text-primary font-medium hover:underline" data-testid="account-orders-link">View order history →</Link>
          <Button onClick={save} disabled={saving} data-testid="save-account-btn">Save changes</Button>
        </div>
      </Card>

      <Card className="p-6 rounded-xl border-border flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div>
          <h3 className="font-semibold">Get the Drelik app</h3>
          <p className="text-sm text-muted-foreground mt-0.5">Install Drelik on your phone for faster access to your orders.</p>
        </div>
        <InstallDrelik variant="default" />
      </Card>
    </div>
  );
}
